import React from "react";
import { Redirect, Route } from 'react-router-dom';
import InPlayer from '../backend/inplayer';
import Global from "../../global";
import { UserStore } from "../store/store";
import Cookies from 'js-cookie';





const PrivateRoute = ({ component: Component, ...rest }) => {

  const verify = UserStore.useState(s => s.user);

  const phone_verifed =  (Cookies.get('sm_ott_val')==="true");

    // Add your own authentication on the below line.

  
    return (
      <Route
        {...rest}
        render={props =>
            InPlayer.Account.isAuthenticated() ? (
              (!verify.PHONE_VERIFIED && !phone_verifed) && Global.OTP && (props.location.pathname!=="/"+props.match.params.AppId+"/verify" && props.location.pathname!=="/"+props.match.params.AppId+"/sendotp") ?
              <Redirect to={{ pathname: '/'+props.match.params.AppId+'/sendotp', state: { from: props.location } }} />:
               (verify.PHONE_VERIFIED||phone_verifed) && Global.OTP && (props.location.pathname==="/"+props.match.params.AppId+"/sendotp" || props.location.pathname==="/"+props.match.params.AppId+"/verify") ? <Redirect to={{ pathname: '/'+props.match.params.AppId+'/home', state: { from: props.location } }} />:
               <Component {...props} />

          ) : (
           
            <Redirect to={{ pathname: '/'+props.match.params.AppId+'/welcome', state: { from: props.location } }} />
          )
        }
      />
    )
  }
  
  export default PrivateRoute